import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import './headerreco.css';

const HeaderReco = () => {
    const [t, i18n] = useTranslation("biblioteca");
    const [t2] = useTranslation("home");

    return (
        <>
        </>
    );
};

export default HeaderReco;